var React = require('react');

function IconChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M20 15l-8-8-8 8","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconChevronUp.defaultProps = {"width":"24","height":"24"};

module.exports = IconChevronUp;

IconChevronUp.default = IconChevronUp;
